const searchResults = document.querySelector('.search-results');

if (searchResults) {
    window.addEventListener('load', () => {
        const searchResultNotice = document.querySelector('.search-results__notice'); 

        if (searchResults.childNodes.length > 0) {
            searchResultNotice.focus();
        }
    })
}
